import { useState } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { FormattedMessage, defineMessages, useIntl } from 'react-intl';
import Loader from '@v7/form/src/components/Loader';
import Input from '@v7/form/src/components/Tools/Input';
import RadioButtonGroup from '@v7/form/src/components/Tools/RadioButtonGroup';
import { useCreateFormMutation } from '@v7/form/src/store/services/updateFormBuilder';

const messages = defineMessages({
  createForm: {
    id: 'form.home.createForm',
    defaultMessage: 'Create Form',
  },
  enterFormName: {
    id: 'form.home.enterFormName',
    defaultMessage: 'Enter Form name',
  },
  goToForm: {
    id: 'form.home.goToForm',
    defaultMessage: 'Go to Form',
  },
});

const Home = () => {
  const intl = useIntl();
  const [isEditFormTitle, setisEditFormTitle] = useState(true);
  const [formData, setFormData] = useState<{ [key: string]: any }>({});
  const [error, setError] = useState('');

  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  const [createForm, { isLoading }] = useCreateFormMutation();

  const createFormBuilder = async () => {
    setError('');
    if (formData.title && formData.type) {
      try {
        const form: any = await createForm({
          name: formData.title,
          type: formData.type?.value,
        });
        if (form?.error) {
          setError(form?.error.message);
        } else {
          navigate(`/builder/${form?.data?.frm_create_form?.data?.id}?accessToken=${searchParams.get('accessToken')}`, {
            replace: true,
          });
        }
      } catch (err) {
        console.log(err);
      }
    } else {
      setError('Form Name and Type is required to create the Form.');
    }
  };

  return (
    <div className="m-auto w-80 mt-2">
      <div
        onClick={() => setisEditFormTitle(true)}
        onKeyDown={(e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            e.preventDefault();
            setisEditFormTitle(true);
          }
        }}
        role="button"
        tabIndex={0}
        className="text-center cursor-pointer"
      >
        <FormattedMessage {...messages.createForm} />
      </div>
      {isEditFormTitle && (
        <div className="mt-2 shadow-lg p-2 rounded ">
          <Input
            onChange={(e) => setFormData((data) => ({ ...data, title: e && e.trim() }))}
            placeholder={intl.formatMessage(messages.enterFormName)}
          />
          <br />
          <RadioButtonGroup
            value={formData?.type}
            label="Please select the Form type"
            onChange={(e: any) => setFormData((data) => ({ ...data, type: e }))}
            options={[
              { value: 'REGISTRATION', label: 'Candidate registration form' },
              { value: 'EVALUATION', label: 'Panel Evaluation form' },
            ]}
          />
          {error && <span className="text-red-600 text-xs mt-4">{error}</span>}
          <br />
          <div className="flex justify-center">
            {isLoading ? (
              <Loader />
            ) : (
              <div
                onClick={createFormBuilder}
                onKeyDown={(e) => {
                  if (e.key === 'Enter' || e.key === ' ') {
                    e.preventDefault();
                    createFormBuilder();
                  }
                }}
                role="button"
                tabIndex={0}
                className="text-center cursor-pointer my-2 hover:underline "
              >
                <FormattedMessage {...messages.goToForm} />
              </div>
            )}
          </div>
        </div>
      )}
    </div>
  );
};

export default Home;
